ValidationEngine = App.loadClass 'core::ValidationEngine'

class exports.WeightSetDialog extends FullPageHandler

    # relevant keycodes for implementing excel-like functionality
    BACKSPACE = 8
    TAB = 9
    ENTER = 13
    LEFT = 37
    UP = 38
    RIGHT = 39
    DOWN = 40
    DELETE = 46
    NUMBERS = [48..57]
    NUMPAD = [96..105]
    NUMERIC = NUMBERS.concat NUMPAD

    init: () ->
        @layoutUrl = 'backend/portal/weightings/weight-set/load-layout'
        @saveUrl = 'backend/portal/weightings/weight-set/save'

        @createDialog()
        @openDialog()
        @displayLoadingMessage()

        @validator = new ValidationEngine()


    getPostData: () ->
        data =
            'ws_id': $('input[name="ws_id"]').val()
            'weights': {}
        for elem in @dialog.find('form input[name="weight"]')
            elem = $(elem)
            hid = elem.attr('data-hybrid-id')
            aid = elem.attr('data-aspect-id')
            data.weights[hid] = {} if not data.weights[hid]
            data.weights[hid][aid] = elem.val()
        return JSON.stringify data


    afterLoadLayout: (selector, response) ->
        if response.status?.type isnt 'success'
            return

        self = this

        # Input Masking
        @dialog.find('.weightset-mask').mask('?99', { placeholder: '' })

        # Handle scrolling
        @dialog.find('.ws-scroll').on 'scroll', () ->
            self.dialog.find('#ws-aspects-container')[0].scrollLeft = @scrollLeft
            self.dialog.find('#ws-hybrids-container')[0].scrollTop = @scrollTop

        # Aspect speedboxes
        @dialog.find('.speedbox-aspect').on 'keyup', (e) ->
            # numeric
            if e.keyCode in NUMERIC or e.keyCode is BACKSPACE or e.keyCode is DELETE
                aspect = $(this).attr('name')
                self.dialog.find('input[name="weight"][data-aspect-id="' + aspect + '"]').val($(this).val()).trigger('change')

            # left
            else if e.keyCode is LEFT
                $(this).closest('th').prev().find('.speedbox-aspect').focus()

            # right
            else if e.keyCode is RIGHT
                $(this).closest('th').next().find('.speedbox-aspect').focus()

        # Hybrid speedboxes
        @dialog.find('.speedbox-hybrid').on 'keyup', (e) ->
            # numeric
            if e.keyCode in NUMERIC or e.keyCode is BACKSPACE or e.keyCode is DELETE
                hybrid = $(this).attr('name')
                self.dialog.find('input[name="weight"][data-hybrid-id="' + hybrid + '"]').val($(this).val()).trigger('change')

            # up
            else if e.keyCode is UP or (e.keyCode is ENTER and e.shiftKey)
                $(this).closest('tr').prev().find('.speedbox-hybrid').focus()

            # down
            else if e.keyCode is DOWN or (e.keyCode is ENTER and not e.shiftKey)
                $(this).closest('tr').next().find('.speedbox-hybrid').focus()

        # weightings navigation
        @dialog.find('input[name="weight"]').on 'keyup', (e) ->
            # left
            if e.keyCode is LEFT
                $(this).closest('td').prev().find('input[name="weight"]').focus()

            # up
            else if e.keyCode is UP or (e.keyCode is ENTER and e.shiftKey)
                aspect = $(this).data('aspect-id')
                $(this).closest('tr').prev().find("input[name='weight'][data-aspect-id='#{aspect}']").focus()

            # right
            else if e.keyCode is RIGHT
                $(this).closest('td').next().find('input[name="weight"]').focus()

            # down
            else if e.keyCode is DOWN or (e.keyCode is ENTER and not e.shiftKey)
                aspect = $(this).data('aspect-id')
                $(this).closest('tr').next().find("input[name='weight'][data-aspect-id='#{aspect}']").focus()

        # weightings validation
        @dialog.find('input[name="weight"]').on 'change', (e) ->
            $(this).addClass('validate-between1and10')

        # Speedbox onBlur
        @dialog.find('.speedbox').on 'blur', () ->
            $(this).val('')


        # Excel export
        @dialog.find('.excel-btn').on 'click', () ->
            url = 'backend/portal/weightings/weight-set/excel-export?weight_set_id=' + $('input[name="ws_id"]').val()
            window.open url, '_blank'


        # Cancel dialog changes by reloading the dialog
        @dialog.find('.cancel-btn').removeAttr('data-dismiss').on 'click', () =>
            @refresh()

        # Validation
        @validator.makeFormValidator 'weight_set', '#table-ws', @dialog.find('.errorDiv'), (valid) =>
            if valid
                @save('Saving Weightings...')

        @validator.registerRule
            'selector': '.validate-between1and10'
            'text': 'Weight must be an integer between 1 and 10'
            'func': (elem) ->
                val = parseFloat($(elem).val())
                return val % 1 is 0 and val >= 1 and val <= 10

        @validator.stopValidating()
        $('.save-btn').bind 'click', () =>
            @validator.startValidating()
            @validator.validateAll()

        # Resize
        $(window).unbind('modal_resized').bind 'modal_resized', debounce (e) =>
            @resize()
        @resize()

    getRemainingHeight: (element) ->
        parentHeight = element.parent().height()
        siblings = element.siblings()
        sibheight = 0
        siblings.each () ->
            sibheight += $(this).outerHeight(true)
        extraHeight = element.outerHeight(true) - element.height()
        return parentHeight - sibheight - extraHeight

    resize: () ->
        ths = this
        element = ths.dialog.find('.modal-body')
        size = ths.getRemainingHeight(element)
        element.css
            height: size + 'px'
        element = ths.dialog.find('ws-scrollarea')
